"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LftIconBase_1 = __importDefault(require("../LftIconBase"));
var LftSkeleton_1 = __importDefault(require("../LftSkeleton"));
var LftTypography_1 = __importDefault(require("../LftTypography"));
var S = __importStar(require("./LftShortcut.styles"));
var LftShortcut = function (_a) {
    var _b, _c;
    var bgColor = _a.bgColor, dataElement = _a.dataElement, dataInfo = _a.dataInfo, dataTestId = _a.dataTestId, disabled = _a.disabled, description = _a.description, icon = _a.icon, id = _a.id, _d = _a.title, title = _d === void 0 ? 'Text' : _d, loading = _a.loading, variant = _a.variant, lftClick = _a.lftClick;
    if (dataElement) {
        if (dataElement.includes('_')) {
            if (typeof window !== 'undefined' && (((_b = window.location.href) === null || _b === void 0 ? void 0 : _b.indexOf("localhost")) > -1 || ((_c = window.location.href) === null || _c === void 0 ? void 0 : _c.indexOf("dev")) > -1)) {
                console.warn('Não é necessário mais colocar o prefixo no atributo dataElement');
            }
        }
        else {
            dataElement = "button_".concat(dataElement);
        }
    }
    return ((0, jsx_runtime_1.jsxs)(S.Wrapper, __assign({ "aria-disabled": disabled, "aria-label": loading ? 'Carregando' : title + " " + description, bgColor: bgColor, "data-element": dataElement, "data-info": dataInfo, "data-lift": "lft-shortcut", "data-testid": dataTestId ? dataTestId : id && id, disabled: disabled, icon: icon, id: id, loading: loading, variant: variant, onClick: lftClick }, { children: [!!loading ? (0, jsx_runtime_1.jsx)(LftSkeleton_1.default, { shape: 'circle' }) : (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { icon: icon }), !!loading ?
                (0, jsx_runtime_1.jsxs)("div", __assign({ className: 'skeleton-lines' }, { children: [(0, jsx_runtime_1.jsx)(LftSkeleton_1.default, { shape: 'line' }), (0, jsx_runtime_1.jsx)(LftSkeleton_1.default, { shape: 'line' })] }))
                : (0, jsx_runtime_1.jsx)("pre", { children: title }), !loading && description && (0, jsx_runtime_1.jsx)(LftTypography_1.default, __assign({ component: 'caption', bgColor: bgColor }, { children: description }))] })));
};
exports.default = LftShortcut;
